import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

const StuckReasonsStyles = muiStyled(Box)(({ theme }) => ({
    height: "100%",
    padding: 20,
    boxSizing: "border-box",
    overflow: "auto",
    '.header': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
    }
}));

export { StuckReasonsStyles }
